module.exports = __webpack_public_path__ + "img/文字版_00.79883ae7.png";